import { ReportType } from '@shared/enums';

/** Types whose Reports-list row exports in place instead of navigating to a report page. */
export const ExportOnlyReports: ReportType[] = [ReportType.Billing];

export const ReportPageTypes: string[] = [
  ReportType.CustomerOverview,
  ReportType.CustomerPoints,
  ReportType.TierProgress,
  ReportType.TransactionPointsHistory,
];
